import { Image } from 'gql/autogen/Image';
import React from 'react';
import { useInView } from 'react-intersection-observer';
import { Box } from '@drone-js/core';
import { ActivityImage } from 'component/common/ActivityImage/ActivityImage';
import { RadiusType } from '@drone-js/theme';

interface ImageComponentProps {
    index: number;
    image: Image;
    altText: string;
    onSeen: (inView: boolean) => void;
    onLoad: (() => void) | undefined;
    onClick: (e: React.MouseEvent) => void;
    imageCount: number;
    imageHeight: string;
}

const getImageRadius = (imageIndex: number, totalImages: number): RadiusType[] => {
    let radius = ['0', '0', '0', '0'] as RadiusType[];
    if (totalImages === 1) {
        // single image
        radius = ['16', '16', '16', '16'] as RadiusType[];
    } else if (imageIndex === 0) {
        // first image
        radius = ['16', '0', '0', '16'] as RadiusType[];
    } else if (imageIndex === totalImages - 1) {
        // last image
        radius = ['0', '16', '16', '0'] as RadiusType[];
    }
    return radius;
};

const ImageContainer: React.FC<ImageComponentProps> = (props) => {
    const { index, image, altText, onSeen, onLoad, imageCount, imageHeight, onClick } = props;
    const [isLoaded, setIsLoaded] = React.useState(false);

    const { ref } = useInView({
        threshold: 0.75,
        triggerOnce: true,
        onChange: onSeen,
    });

    const internalOnLoad = () => {
        if (onLoad) onLoad();
        setIsLoaded(true);
    };

    return (
        <Box minWidth="fit-content" ref={isLoaded ? ref : null} onClick={onClick} as="button" px="0">
            <ActivityImage
                data-elelment-name={`activities-image-carousel-${index}`}
                src={image.url || ''}
                alt={altText}
                title={image.description}
                onLoad={internalOnLoad}
                borderRadius={getImageRadius(index, imageCount)}
                height={imageHeight}
                loading="immediate"
                responsive="original"
                width="auto"
                activityId={image.activityId}
                supplierId={image.supplierId}
            />
        </Box>
    );
};

ImageContainer.displayName = 'ImageComponent';

export default ImageContainer;
